import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el material?',
  a: 'Al completar el pago recibís un email con acceso inmediato a todos los PDFs. Descargalos en tu teléfono, tablet o computadora y usalos desde hoy mismo.'
}, {
  q: '¿Sirve si soy profe nuevo o si tengo experiencia?',
  a: 'Sí para los dos. Si sos nueva: tenés todo organizado desde el primer día. Si ya tenés experiencia: vas a encontrar ideas, variaciones y estructuras que no tenías sistematizadas.'
}, {
  q: '¿Los 6 Bonus están en las dos opciones?',
  a: 'Sí. Los 6 Bonus están incluidos tanto en el Pack Profesional como en el Megapack Élite. La diferencia son los 2 Ebooks Élite exclusivos.'
}, {
  q: '¿Qué diferencia hay con otros materiales de Pilates que ya existen?',
  a: 'PILATES 360 es el único sistema pensado específicamente para el instructor argentino, con progresión real por niveles, ejercicios graficados, Reformer y Mat en un solo lugar, y un plan anual completo incluido.'
}, {
  q: '¿Sirve para grupos con niveles mezclados?',
  a: 'Sí. Cada tomo incluye variaciones esencial, clásica y avanzada del mismo ejercicio para que des una sola clase con tres niveles sin planificar tres veces.'
}, {
  q: '¿Qué pasa si no me sirve?',
  a: 'Tenés 7 días de garantía total. Si por cualquier motivo no es lo que esperabas, te devolvemos el 100% del pago. Sin formularios ni preguntas.'
}, {
  q: '¿Vale la pena el Megapack Élite si ya planifico bien mis clases?',
  a: 'Si ya planificás bien, el Élite #2 (Variaciones Infinitas) va a darte 100 variaciones nuevas de los ejercicios que ya usás. Y el Élite #1 te va a dar el año completo estructurado sin trabajo extra. El tiempo que ahorrás en un mes ya justifica la diferencia de precio.'
}, {
  q: '¿Puedo pagar con tarjeta de crédito?',
  a: 'Sí. Aceptamos todas las tarjetas de crédito y débito, transferencia bancaria y Mercado Pago.'
}];
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 bg-white" data-id="element-38">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-39">
        {/* FAQ Section */}
        <div data-id="element-40">
          <h2 className="text-4xl font-serif font-bold text-brand-charcoal mb-12 text-center" data-id="element-41">
            Preguntas Frecuentes
          </h2>
          <div className="space-y-4" data-id="element-42">
            {faqs.map((faq, i) => <div key={i} className="border border-brand-sand rounded-xl overflow-hidden" data-id="element-43">
                <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-4 text-left flex justify-between items-center bg-brand-cream hover:bg-brand-sand/20 transition-colors" data-id="element-44">
                  <span className="font-bold text-brand-charcoal pr-4" data-id="element-45">
                    {faq.q}
                  </span>
                  <ChevronDown className={`transform transition-transform duration-300 text-brand-terracotta flex-shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} size={20} data-id="element-46" />
                </button>
                <AnimatePresence data-id="element-47">
                  {openIndex === i && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-48">
                      <div className="px-6 py-4 bg-white text-gray-600 leading-relaxed border-t border-brand-sand" data-id="element-49">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};